import React, { useState } from 'react';
import { Link, useLocation } from 'wouter';
import { Logo } from './Logo';
import { useLang } from '@/i18n/LangContext';
import { Menu, X } from 'lucide-react';

function FlagES() {
  return (
    <svg viewBox="0 0 20 15" width="24" height="18" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
      {/* Spain flag: red-yellow-red */}
      <rect width="20" height="15" fill="#c60b1e"/>
      <rect y="3.75" width="20" height="7.5" fill="#ffc400"/>
    </svg>
  );
}

function FlagEN() {
  return (
    <svg viewBox="0 0 20 15" width="24" height="18" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
      <rect width="20" height="15" fill="#B22234"/>
      <rect y="1.15" width="20" height="1.15" fill="#FFFFFF"/>
      <rect y="3.46" width="20" height="1.15" fill="#FFFFFF"/>
      <rect y="5.77" width="20" height="1.15" fill="#FFFFFF"/>
      <rect y="8.08" width="20" height="1.15" fill="#FFFFFF"/>
      <rect y="10.38" width="20" height="1.15" fill="#FFFFFF"/>
      <rect y="12.69" width="20" height="1.15" fill="#FFFFFF"/>
      <rect width="8" height="8" fill="#3C3B6E"/>
    </svg>
  );
}

export function Navbar() {
  const [location] = useLocation();
  const { lang, setLang, tr } = useLang();
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleLang = () => setLang(lang === 'es' ? 'en' : 'es');

  const navLinks = [
    { href: '/', label: tr.nav.home },
    { href: '/nosotros', label: tr.nav.about },
    { href: '/servicios', label: tr.nav.services },
    { href: '/portafolio', label: tr.nav.portfolio },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/85 backdrop-blur-xl border-b border-border/40">
      <div className="max-w-7xl mx-auto px-6 h-24 flex items-center justify-between">
        <Link href="/" onClick={() => setMobileOpen(false)}>
          <Logo />
        </Link>

        {/* Desktop nav */}
        <div className="hidden lg:flex items-center gap-6">
          <div className="flex items-center gap-5">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className={`text-sm font-medium transition-colors ${
                  location === link.href ? 'text-primary' : 'text-muted-foreground hover:text-primary'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
          <div className="flex items-center gap-4 border-l border-border/50 pl-4">
            <button
              onClick={toggleLang}
              title={lang === 'es' ? 'Switch to English' : 'Cambiar a Español'}
              className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-muted-foreground hover:text-primary transition-colors rounded-md hover:opacity-80"
              style={{ cursor: 'pointer' }}
            >
              {lang === 'es' ? <FlagEN /> : <FlagES />}
              <span>{lang === 'es' ? 'EN' : 'ES'}</span>
            </button>
            <Link
              href="/contacto"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-bold tracking-wide h-10 px-6 py-2 bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
            >
              {lang === 'es' ? 'Contactar' : 'Contact Us'}
            </Link>
          </div>
        </div>

        {/* Mobile toggle */}
        <div className="lg:hidden flex items-center gap-3">
          <button
            onClick={toggleLang}
            className="flex items-center gap-1 hover:opacity-80 transition-opacity"
            style={{ cursor: 'pointer' }}
          >
            {lang === 'es' ? <FlagEN /> : <FlagES />}
          </button>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="p-2 text-muted-foreground hover:text-primary transition-colors"
            aria-label="Menú"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-background border-t border-border/40 px-6 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className={`text-base font-medium transition-colors ${
                location === link.href ? 'text-primary' : 'text-muted-foreground hover:text-primary'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            href="/contacto"
            onClick={() => setMobileOpen(false)}
            className="inline-flex items-center justify-center rounded-md text-sm font-bold h-12 px-6 bg-primary text-primary-foreground hover:bg-primary/90 transition-colors mt-2"
          >
            {lang === 'es' ? 'Contactar' : 'Contact Us'}
          </Link>
        </div>
      )}
    </nav>
  );
}
